export default {"src":"/_next/static/media/Belgium.aa95359f.svg","height":15,"width":20,"blurWidth":0,"blurHeight":0};